// Routes for Laporan Module
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const Kepesertaan = lazy(() => import('../pages/reports/laporan/Kepesertaan'));
const LaporanLB1 = lazy(() => import('../pages/reports/laporan/LaporanLB1'));
const Prolanis = lazy(() => import('../pages/reports/laporan/Prolanis'));
const IbuHamil = lazy(() => import('../pages/reports/laporan/IbuHamil'));
const PesertaKB = lazy(() => import('../pages/reports/laporan/PesertaKB'));
const PesertaProlanisPRB = lazy(() => import('../pages/reports/laporan/PesertaProlanisPRB'));
const PenyakitMenular = lazy(() => import('../pages/reports/laporan/PenyakitMenular'));
const MedicalRecordReports = lazy(() => import('../pages/reports/medical-records/MedicalRecordReports'));
const LaporanICV = lazy(() => import('../pages/reports/laporan/LaporanICV'));
const SatuSehatPage = lazy(() => import('../pages/administrasi/SatuSehatPage'));

export const getLaporanRoutes = () => {
  return (
    <>
      <Route path="/reports/kepesertaan" element={<Kepesertaan />} />
      <Route path="/reports/lb1" element={<LaporanLB1 />} />
      <Route path="/reports/prolanis" element={<Prolanis />} />
      <Route path="/reports/ibu-hamil" element={<IbuHamil />} />
      <Route path="/reports/peserta-kb" element={<PesertaKB />} />
      <Route path="/reports/peserta-prolanis-prb" element={<PesertaProlanisPRB />} />
      <Route path="/reports/penyakit-menular" element={<PenyakitMenular />} />
      <Route path="/reports/medical-records" element={<MedicalRecordReports />} />
      <Route path="/reports/icv" element={<LaporanICV />} />
      <Route path="/reports/satusehat-bulk" element={<SatuSehatPage />} />
    </>
  );
};

// Trigger refresh for LaporanICV
